import APIController from "../../controller/APIController";
import { useEffect, useState } from "react";
import LoadingScreen from "../../includes/LoadingScreen";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DateTimeUtil from "../../util/DateTimeUtil";
import UserController from "../../controller/UserController";

import './SupervisorDetails.css'
import {
    faSheetPlastic, 
  faUserTie,
  faEnvelope, faMobile,  faClock, faUsers,
  faUser,
  faAddressBook,
  faCubes,
  faPerson
} from "@fortawesome/free-solid-svg-icons";

export default function SupervisorDetails(props) {
    let supervisorId = props.params?.supervisorId;
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [supervisor, setSupervisor] = useState(null);

    useEffect(() => {
        setLoading(true);
        const fetchSupervisor = async () => {
            if (supervisorId) {
                try {
                    const record = await APIController.getSingleSupervisorById(supervisorId);
                    setSupervisor(record);
                } catch (error) {
                    setError(error);
                    console.error("Error fetching supervisor:", error);
                }finally {
                    setLoading(false);
                }
            }
        };

        fetchSupervisor();
    }, [supervisorId]);

    return (
        <div class="mt-2 p-3 p-md-5">  
            {!loading ? (
                supervisor && !error &&
                <div className="p-0">
                    <div className="supervisorCard">
                     <h3 style={{marginBottom:'1em'}}><FontAwesomeIcon icon={faUserTie} /> {supervisor.firstName + " " + supervisor.lastName}</h3>
                    <div>
                        <p><FontAwesomeIcon icon={faEnvelope} /><strong> E-Mail:</strong> <a href={`mailto:${supervisor.email}`}>{supervisor.email}</a></p>
                        <p><FontAwesomeIcon icon={faMobile} /><strong> Telefon:</strong> <a href={`tel:${supervisor.phone}`}>{supervisor.phone}</a></p>
                        <p><FontAwesomeIcon icon={faClock} /><strong> Einladung angenommen am:</strong> {DateTimeUtil.getHumanReadableDate(supervisor.createdOn)}</p>
                    </div>
                    </div>
                    <div className={"mt-5"}>
                    <h4><FontAwesomeIcon icon={faUsers} /> Meine Auszubildenden</h4>
                    <div className="row">
                    {supervisor.connectedTrainees.length > 0 ? (
                          
                              <>
                                 {supervisor.connectedTrainees.map( (cTrainee, idx) => (
                                    <div className="col col-12 col-sm-12 col-lg-6 col-xl-4">
                                        <a title="Portfolio anzeigen" href={UserController.getPortfolioURL(cTrainee._id)} ><div className="traineeCard">
                                            <img style={{width:'50px'}} src={cTrainee.profileImage} />
                                            <h4 style={{display:'inline-block',marginLeft:'0.5em'}}>{cTrainee.firstname+ ' ' + cTrainee.name }<br /><small style={{fontSize:'0.7em'}}>Teilnehmer-Nr: {cTrainee.externalId}</small></h4>
                                            <p>
                                                <br /><span className="cardtitle">Beruf</span> <span className="cardValue">{cTrainee.professionName}</span>
                                                <br /><span className="cardtitle">Ausbildungszeitraum</span> <span className="cardValue">{DateTimeUtil.getHumanReadableDate(cTrainee.trainingStartDate)} - {DateTimeUtil.getHumanReadableDate(cTrainee.trainingEndDate)}</span>
                                                <br /><span className="cardtitle">Ausbildungsdauer</span> <span className="cardValue">{cTrainee.trainingDurationInMonths} Monate</span>
                                            </p>
                                                      
                                            <button className="btn btn-info cardButton mb-2" onClick={(e) => {
                                                    e.preventDefault();
                                                    window.location = `/supervisor/topics/${cTrainee.professionId}/trainee/${cTrainee._id}`;
                                                }}><FontAwesomeIcon icon={faCubes} /> Projekte</button>
                                                <button className="btn btn-default cardButton mb-2" onClick={(e) => {
                                                    e.preventDefault();
                                                    window.location = `/trainee/${cTrainee._id}/worksheets`;
                                                }}><FontAwesomeIcon icon={faSheetPlastic}/> Digitale Arbeitsblätter</button>
                                        </div></a>
                                    </div>
                                ))}
                                </>
                    ) : (
                        <div className={""}>
                            <p>Kein Auszubildender</p>
                        </div>
                    )}
                    </div>
                    </div>
                </div>
            ) : (
                <LoadingScreen />
            )}
        </div>
    );
}
